module.exports = __webpack_public_path__ + "assets/img/gift-title-2dac5e01.png";